<script setup>
import { useStore } from 'vuex';
const store = useStore();
store.dispatch("logUserOut");
</script>
<template>
    <h1>Signout</h1>
</template>